import React from 'react';

const ChipsUI = (props) => {
    const onClick = (item) => {
        if (props.onClick) {
            props.onClick(item);
        }
    };

    const color = (item) => {
        var styles = {
            backgroundColor: item.selected ? 'var(--third-text-color)' : "#e4e4e4",
            color: item.selected ? 'white' : 'black',
            cursor: 'pointer'
        }
        return styles;
    }

    return (
        props.array && props.array.map((item) => (
            <div key={item.key} onClick={() => onClick(item.key)} className="chip" style={color(item)}>
                {item.text}
            </div>
        ))
    );
};

export default ChipsUI;
